<div *ngIf="(global.globalAgencyId==null ||global.globalAgencyId==undefined ||
global.globalAgencyId=='' || global.globalAgencyId=='00000000-0000-0000-0000-000000000000')">
    <div class="row mb-2">
        <div class="col pl-0">
            <div widget class="card border-0 box-shadow">
                <div class="card-body  widget-body pt-2">
                    <div class="text-center text-danger">
                        <label class="font-red"><i class="fa fa-info-circle fa-lg"></i>&nbsp;Select agency to view
                            details</label>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div  class="row mb-2" *ngIf="(global.globalAgencyId!=null && global.globalAgencyId!=undefined  &&
global.globalAgencyId!=''&& global.globalAgencyId!='00000000-0000-0000-0000-000000000000')">
<div class="col-12">
    <h4 class="mb-2 py-1 font-header-1">Tax Details</h4>
</div>
   
</div>


<!-- ejs-grid -->
<div  class="row mb-2" *ngIf="(global.globalAgencyId!=null && global.globalAgencyId!=undefined  &&
global.globalAgencyId!=''&& global.globalAgencyId!='00000000-0000-0000-0000-000000000000')">
    <div class="col p-0">
        <div widget class="card border-0 box-shadow">
            <div class="row">
                <div class="col-lg-12 col-md-12">
                    <nav>
                        <div class="nav nav-tabs nav-fill " id="nav-tab" role="tablist" >
                            <a class="nav-item nav-link active" id="nav-tax-tab" data-bs-toggle="tab"
                                href="#nav-tax" role="tab"
                                [ngClass]="{'mytab-inactive':TaskTab!='nav-tax','active':TaskTab=='nav-tax' }"
                                aria-controls="nav-tax" aria-selected="true"
                                (click)="tabChanged('nav-tax')">Tax</a>

                                <a class="nav-item nav-link " id="nav-taxpercent-tab" data-bs-toggle="tab"
                                href="#nav-taxpercent"
                                [ngClass]="{ 'mytab-inactive':TaskTab!='nav-taxpercent','active':TaskTab=='nav-taxpercent' }"
                                role="tab" aria-controls="nav-taxpercent" aria-selected="false"
                                (click)="tabChanged('nav-taxpercent')">Taxpercent</a>

                            <a class="nav-item nav-link " id="nav-relationship-list-tab" data-bs-toggle="tab"
                                href="#nav-relationship-list" role="tab"
                                [ngClass]="{ 'mytab-inactive':TaskTab!='nav-relationship-list','active':TaskTab=='nav-relationship-list'}"
                                aria-controls="nav-relationship-list" aria-selected="false"
                                (click)="tabChanged('nav-relationship-list')">Relationship List</a>

                         

                        </div>
                    </nav>
                    <div class="tab-content" id="nav-tabContent">
                        <!-- tax -->
                        <div class="tab-pane fade  " id="nav-tax" role="tabpanel" aria-labelledby="nav-tax"
                            [ngClass]="{'active':TaskTab=='nav-tax','show':TaskTab=='nav-tax'}">
                          
                        </div>
                    </div>
                     <!-- taxpercent -->
                     <div class="tab-pane fade" id="nav-taxpercent" role="tabpanel"
                     aria-labelledby="nav-taxpercent"
                     [ngClass]="{'active':TaskTab=='nav-taxpercent','show':TaskTab=='nav-taxpercent'}">
                
                 </div>
                    <!-- relationshiplist -->
                    <div *ngIf="TaskTab=='nav-relationship'">
                        <div class="tab-pane fade" id="nav-relationship" role="tabpanel"
                            aria-labelledby="nav-relationship"
                            [ngClass]="{'active':TaskTab=='nav-relationship','show':TaskTab=='nav-relationship'}">
                           
                        </div>
                    </div>
                   

                </div>
                <app-taxs  *ngIf="isViewTaskDetails">
                </app-taxs>

                <app-taxs-percent  *ngIf="isViewTaskPercent">
                </app-taxs-percent>

                <app-relationship-list *ngIf="isViewRelationshipList" >
                </app-relationship-list>

         

            </div>
        </div>
    </div>
</div>


  
   
